import React from "react";
import CurrentFlowStep from "../currentFlowStep";
import { ApplicationFlowPropType, ApplicationFlows } from "../types";
import ApplicationFlowProvider from "../applicationFlowContext";

export default function AdditionalCardApplicationFlow({
  activeChapter,
  step,
  setStep,
  basicAccountApplication,
  cardApplication,
  triggerReload,
}: ApplicationFlowPropType): React.JSX.Element {
  return (
    <ApplicationFlowProvider
      flow={ApplicationFlows.ADDITIONAL_CA}
      activeChapter={activeChapter}
      setStep={setStep}
    >
      <CurrentFlowStep
        flowType={ApplicationFlows.ADDITIONAL_CA}
        step={step}
        setStep={setStep}
        basicAccountApplication={basicAccountApplication}
        cardApplication={cardApplication}
        triggerReload={triggerReload}
      />
    </ApplicationFlowProvider>
  );
}
